import Exchange from '..'
import Actions from './Actions'
import { fetchMarkets } from 'store/actions'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const Margin = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchMarkets({
      type: 'MARGIN',
    }))
  }, [])
  return (
    <Exchange>
      <Actions />
    </Exchange>
  )
}

export default Margin
